var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 44,
    viewBox: "0 0 30 44",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0.400024C7.03883 0.400024 0.599976 7.16082 0.599976 15.52C0.599976 26.86 15 43.6 15 43.6C15 43.6 29.4 26.86 29.4 15.52C29.4 7.16082 22.9611 0.400024 15 0.400024ZM15 20.92C12.1611 20.92 9.85712 18.5008 9.85712 15.52C9.85712 12.5392 12.1611 10.12 15 10.12C17.8388 10.12 20.1428 12.5392 20.1428 15.52C20.1428 18.5008 17.8388 20.92 15 20.92Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.379cfaa5dee90d09df1af8a37906e9a7.svg";
export { ForwardRef as ReactComponent };